import countriesData from "./Countries.json";

export const getCountries = () => {
  return countriesData.countries;
};
